import MyStopsList from './container'

export default MyStopsList
